import { ErrorHandler, Injectable, Injector, inject } from '@angular/core';
import { TelemetryService } from './telemetry.service';

/**
 * El `ErrorHandler` de Angular de siempre —el error sigue saliendo por consola— que además lo
 * registra en la telemetría. El servicio se pide al vuelo: el `ErrorHandler` se construye antes
 * que casi todo, y pedirlo en el constructor ataría el arranque al router y a la autenticación.
 */
@Injectable()
export class TelemetryErrorHandler extends ErrorHandler {
    private injector = inject(Injector);

    override handleError (error: unknown): void {
        super.handleError(error);
        try {
            this.injector.get(TelemetryService).captureError(error, 'angular');
        } catch { /* registrar un error nunca puede producir otro */ }
    }
}
